require('./base-script');

window._ = require('lodash');
Vue.component('pagination', require('laravel-vue-pagination'));